import React, { useEffect, useState } from "react";
import {
  AddHeaderFooterToolIcon,
  AddPageToolIcon,
  AiChatToolIcon,
  ArrowSendIcon,
  ChevronDownIcon,
  CompressPDFToolIcon,
  CropToolIcon,
  EditPDFToolIcon,
  HtmlToolIcon,
  InvoiceIcon,
  JPGToolIcon,
  MergeToolIcon,
  OCRToolIcon,
  ProtectPDFToolIcon,
  QAToolIcon,
  RemovePageToolIcon,
  SearchToolIcon,
  SignToolIcon,
  ToolMenuIcon,
  WordToolIcon,
} from "../icons/SVGs";
import { Button, NavItems } from "../index";
import { MenuIcon } from "@heroicons/react/outline";
import { useTranslation } from "react-i18next";
import LanguageMenu from "../language";
import { useDispatch, useSelector } from "react-redux";
import {
  logout,
  profileUpdate,
  selectUser,
} from "../../redux/slices/userSlice";
import ProfileDropdown from "../profile/ProfileDropDown";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";
import { HttpService } from "../../services/base.service";
import { azureService } from "../../services/azure.service";
import { authService } from "../../services/auth.service";
import Popups from "../Model/base";

const Header = () => {
  const { t, i18n } = useTranslation();
  const [menuShow, setMenuShow] = useState(false);
  const [showNav, setShowNav] = useState(false);
  const [popup, setPopup] = useState(false);
  const [state, setState] = useState(-1);
  const [token, setToken] = useState(null);
  const [isLoading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const { profile } = useSelector(selectUser);
  const html = document.getElementsByTagName("html")[0].dir;

  const navigation = [
    {
      name: "Home",
      display: t("Home"),
      href: `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}`,
      current: false,
    },
    {
      name: "About us",
      display: t("About us"),
      href: `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/aboutus`,
      current: false,
    },
    {
      name: "Pricing",
      display: t("Pricing"),
      href: `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/subscription-plans`,
      current: false,
    },
    {
      name: "Contact us",
      display: t("Contact us"),
      href: `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/contactus`,
      current: false,
    },
  ];
  const megaMenu = {
    view: [
      {
        icon: EditPDFToolIcon,
        title: t("Edit PDF"),
        action: () => {
          window.location.href = `/${i18n.language}/edit-pdf`;
        },
      },
      {
        icon: AddPageToolIcon,
        title: t("Add Page"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/add-pdf-pages`;
        },
      },
      {
        icon: RemovePageToolIcon,
        title: t("Remove Page"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/remove-pdf-pages`;
        },
      },
      {
        icon: AddHeaderFooterToolIcon,
        title: t("Add Header & Footer"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/header-footer-pdf`;
        },
      },
    ],
    compress: [
      {
        icon: CompressPDFToolIcon,
        title: t("Compress PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/compress-pdf`;
        },
      },
    ],
    convertFromPdf: [
      {
        icon: JPGToolIcon,
        title: t("PDF to JPG"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/convert-pdf-to-jpg`;
        },
      },
      {
        icon: WordToolIcon,
        title: t("PDF to Word"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/convert-pdf-to-word`;
        },
      },
    ],
    convertToPdf: [
      {
        icon: HtmlToolIcon,
        title: t("HTML to PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/convert-html-to-pdf`;
        },
      },
    ],
    signature: [
      {
        icon: SignToolIcon,
        title: t("Fill & Sign"),
        action: () => {
          window.location.href = `/${i18n.language}/fill-and-sign`;
        },
      },
    ],
    more: [
      {
        icon: MergeToolIcon,
        title: t("Merge PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/merge-pdf`;
        },
      },
      {
        icon: ProtectPDFToolIcon,
        title: t("Protect PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/protect-pdf`;
        },
      },
      {
        icon: CropToolIcon,
        title: t("Crop PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/crop-pdf`;
        },
      },
      {
        icon: OCRToolIcon,
        title: t("OCR PDF"),
        action: () => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/ocr-pdf`;
        },
      },
      {
        icon: SearchToolIcon,
        title: t("Search and Replace"),
        action: () => {
          window.location.href = `/${i18n.language}/search-and-replace`;
        },
      },
    ],
    aiPdf: [
      {
        icon: AiChatToolIcon,
        title: t("AI Chat with PDF"),
        tag: t("POPULAR"),
        action: () => {
          handleAuth();
        },
      },
    ],
    invoicing: [
      {
        icon: InvoiceIcon,
        title: t("Invoices"),
        tag: t("NEW"),
        action: () => {
          setMenuShow(false);
          setShowNav(false);
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${
            i18n.language
          }${token ? "/invoices" : "/invoices/create"}`;
        },
      },
    ],
    quiz: [
      {
        icon: QAToolIcon,
        title: t("AI Quiz"),
        tag: t("NEW"),
        action: () => {
          setShowNav(false);
          setMenuShow(false);
          localStorage.removeItem("convertTo");
          localStorage.setItem("tab", "qa");
          window.location.href = `/${i18n.language}/features/qa-generate-pdf`;
        },
      },
    ],
  };

  const verifyToken = (session_id) => {
    let success = false;

    HttpService.setToken(session_id);
    if (HttpService.isTokenSet()) {
      console.log("Token is set");
      success = true;
    }
    return success;
  };

  useEffect(() => {
    const session_id = Cookies.get("session_id");

    if (session_id) {
      const cond1 = Cookies.get("session_id");
      const cond2 = verifyToken(session_id);

      if (cond1 && cond2) {
        authService
          .auth({})
          .then((user) => {
            if (user.status === 200 || user.status === 201) {
              dispatch(profileUpdate(user.data));
              setToken(session_id);
              setLoading(false);
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error("Session Expire");
            if (error.response?.data?.status === 401) {
              Cookies.remove("session_id", {
                domain: process.env.REACT_APP_PUBLIC_DOMAIN,
                path: "/",
              });
              dispatch(logout());
            }
            setLoading(false);
          });
      } else {
        handleTokenSetFailure();
      }
    } else {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1100) {
        setShowNav(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const session_id = Cookies.get("session_id");

    if (session_id) {
      setToken(session_id);
    } else {
      setToken(null);
    }
  }, [profile]);

  const handleAuth = () => {
    const session_id = Cookies.get("session_id");

    if (session_id) {
      HttpService.setToken(session_id);

      azureService
        .projectStatus({})
        .then((res) => {
          window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/features/pdf-chat`;
        })
        .catch((error) => {
          const { response } = error;

          if (response?.data?.status === 401) {
            toast.error("Session Expired");
            Cookies.remove("session_id", {
              domain: process.env.REACT_APP_PUBLIC_DOMAIN,
              path: "/",
            });
            window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/login`;
          } else if (response?.data?.message.includes("Quota Reached")) {
            setState(11);
            setPopup(true);
          } else {
            if (!window.location.pathname.includes("/my-project")) {
              setTimeout(() => {
                window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/my-project`;
              }, 1500);
            }

            if (
              !response?.data?.message.includes(
                "AI Project Quota Reached: Please Upgrade Your Plan"
              )
            ) {
              toast.error(response?.data?.message);
            }
          }
        });
    } else {
      toast.error("No session found. Please log in.");
      window.location.href = `${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}/login`;
    }
  };

  const handleTokenSetFailure = () => {
    toast.error(t("Failed to set token"));
    setLoading(false);
  };

  return (
    <>
      <header
        className={`bg-white border-b border-secondary-30 shadow-header !fixed !top-0 w-full !z-50`}
      >
        <div className="flex items-center justify-between sm:py-3.5 py-3 w-full lg-wide:gap-x-6 gap-2 2xl:gap-x-11 px-4 xl:px-8 max-w-[1920px] mx-auto">
          <a
            href={`${process.env.REACT_APP_FRONTEND_URL}/${i18n.language}`}
            className="cursor-pointer xl:w-32 w-30 h-12 relative flex-shrink-0"
          >
            <img
              src="https://gopdf.s3.eu-central-1.amazonaws.com/logos/Logo+go+pdf.svg"
              alt="Go PDF"
              fill={true}
              className="w-full h-full object-contain"
            />
          </a>
          <div className="flex lg-wide:justify-between justify-end sm:w-full">
            <div
              className={`flex ${
                showNav
                  ? "absolute top-full z-40 w-full pt-2 pb-8 px-4 md:p-5 left-0 shadow-9xl bg-white flex-col items-center gap-6 lg-wide:hidden overflow-y-auto h-[calc(100vh-4.5rem)]"
                  : "hidden lg-wide:flex items-center 2xl:gap-10 lg-wide:gap-6 gap-4"
              }`}
            >
              <nav
                className={`${
                  showNav && "w-full"
                } flex lg-wide:flex-row flex-col lg-wide:items-center xl:gap-6 gap-4`}
              >
                <div
                  className={`flex items-center gap-1.5 w-full lg-wide:w-auto cursor-pointer ${
                    menuShow ? "text-primary" : "text-secondary-1000"
                  }`}
                  onClick={() => {
                    setMenuShow(!menuShow);
                  }}
                >
                  <ToolMenuIcon className="w-4.5 h-4.5" />
                  <span
                    className={`2xl:text-base xl:text-[15px] text-sm font-normal`}
                  >
                    {t("PDF Tools")}
                  </span>
                  <ChevronDownIcon
                    className={`${
                      menuShow ? "rotate-180" : ""
                    } w-3.5 h-3.5 ml-auto lg-wide:ml-0`}
                  />
                </div>
                {menuShow && (
                  <div
                    className="w-full h-full bg-transparent fixed inset-0 z-10"
                    onClick={() => {
                      setMenuShow(false);
                    }}
                  />
                )}
                <div
                  className={`lg-wide:absolute lg-wide:top-18 2xl:top-18 mt-1 inset-x-0 z-30 lg-wide:border-t-2 lg-wide:border-primary lg-wide:pt-9 lg-wide:pb-10 bg-white lg-wide:shadow-9xl ${
                    menuShow ? "flex" : "hidden pointer-events-none"
                  }`}
                >
                  <ul className="grid lg-wide:grid-cols-4 md:grid-cols-2 sm:grid-cols-2 grid-cols-1 lg-wide:gap-6 gap-4 w-full max-w-9xl mx-auto lg-wide:px-6 xl:px-8">
                    <div className="space-y-2">
                      <NavItems
                        title={t("View & Edit")}
                        options={megaMenu.view}
                      />
                      <NavItems
                        title={t("Compress")}
                        options={megaMenu.compress}
                      />
                    </div>
                    <div className="space-y-2">
                      <NavItems
                        title={t("Convert from PDF")}
                        options={megaMenu.convertFromPdf}
                      />
                      <NavItems
                        title={t("Convert to PDF")}
                        options={megaMenu.convertToPdf}
                      />
                      <NavItems
                        title={t("Signature")}
                        options={megaMenu.signature}
                      />
                    </div>
                    <NavItems title={t("More")} options={megaMenu.more} />
                    <div className="space-y-2">
                      <NavItems title={t("AI PDF")} options={megaMenu.aiPdf} />
                      <NavItems
                        title={t("Invoicing")}
                        options={megaMenu.invoicing}
                      />
                      <NavItems title={t("Quiz")} options={megaMenu.quiz} />
                    </div>
                  </ul>
                </div>
                <hr className="lg-wide:hidden" />
                <ul
                  className={`flex ${
                    showNav ? "flex-col gap-4" : "items-center 2xl:gap-8 gap-4"
                  } 2xl:pl-3`}
                >
                  {navigation.map((item, index) => (
                    <li key={index}>
                      <a
                        href={item.href}
                        className={`${
                          window.location.pathname === item.href
                            ? "text-primary"
                            : "text-secondary-600 hover:text-secondary-900"
                        } 2xl:text-base xl:text-[15px] text-sm font-normal`}
                      >
                        {item.display}
                      </a>
                    </li>
                  ))}
                </ul>
              </nav>
              <Button
                variant="btn-secondary"
                className="w-full lg-wide:w-auto !justify-between gap-2 !px-4 xl:px-6"
                value={t("AI Chat with PDF")}
                iconEnd={
                  <ArrowSendIcon
                    className={`${
                      html === "rtl" ? "rotate-90" : "-rotate-90"
                    } w-4 h-4`}
                  />
                }
                onClick={() => {
                  localStorage.setItem("tab", "pdf-chat");
                  handleAuth();
                }}
              />
            </div>
            <div className={`flex items-center gap-3 lg:gap-5`}>
              <div
                className="flex items-center"
                onClick={() => {
                  setShowNav(false);
                }}
              >
                <LanguageMenu />
              </div>
              {!isLoading &&
                (token ? (
                  <ProfileDropdown
                    profile={profile}
                    userName={profile?.fullName}
                  />
                ) : (
                  <Button
                    value={t("Get Started")}
                    onClick={() => {
                      setState(1);
                      setPopup(true);
                    }}
                  />
                ))}
              <Button
                onClick={() => {
                  setShowNav(!showNav);
                }}
                icon={
                  <MenuIcon className="block sm:w-6 w-5 sm:h-6 h-5 flex-shrink-0" />
                }
                variant="btn-white"
                className={`hover:btn-gray lg-wide:hidden w-10 h-10 px-0 ${
                  showNav ? "btn-gray" : ""
                }`}
                isIcon
              />
            </div>
          </div>
        </div>
        {state && (
          <Popups
            show={popup}
            hide={setPopup}
            state={state}
            setstate={setState}
            handleStates={null}
            triggerReload={null}
          />
        )}
      </header>
      <div className="pb-26 bg-transparent"></div>
    </>
  );
};

export default Header;
